<template>
  <div class="hm-home">
    <div class="flex table-panel">
      <el-radio-group size="small" @change="switchTab" v-model="activeTab">
        <el-radio-button
          v-for="(v, i) in statusList"
          :key="i"
          :label="v.value"
          >{{ v.name }}</el-radio-button
        >
      </el-radio-group>
    </div>
    <component @switchTab="switchTab" :is="activeTab"></component>
  </div>
</template>
<script>
import examineTasK from "./modules/examineTasK";
import examineGroup from "./modules/examineGroup";
import indicatorField from "./modules/indicatorField";
import performanceLevel from "./modules/performanceLevel";
export default {
  components: {
    examineTasK,
    examineGroup,
    indicatorField,
    performanceLevel
  },
  data() {
    return {
      activeTab: "examineTasK",
      statusList: [
        {
          name: "考核任务设置",
          value: "examineTasK"
        },
        {
          name: "考核组设置",
          value: "examineGroup"
        },
        {
          name: "指标字段设置",
          value: "indicatorField"
        },
        {
          name: "绩效等级设置",
          value: "performanceLevel"
        }
      ]
    };
  },
  created() {
    const activeTab = this.$route.query.activeTab;
    if (activeTab) {
      this.activeTab = activeTab;
    }
  },
  mounted() {},
  watch: {},
  methods: {
    switchTab(activeTab) {
      this.activeTab = activeTab;
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  background: #fff;
  padding: 15px;
}
.table-panel {
  background: #fff;
  padding: 15px;
}

.table {
  .line {
    width: 1px;
    margin: 0 10px;
    height: 12px;
    background: #ddd;
  }
}
</style>
